import { usePostMutation } from "@/api/swr/useMutation";
import { improvementProposalCreateSchema } from "@/schema/console/improvement-proposals/ImprovementProposalCreate";
import { z } from "zod";

type Config = Parameters<
  typeof usePostMutation<typeof improvementProposalCreateSchema, z.ZodNull>
>[3];

export const useCreateImprovementProposal = (id: string, config?: Config) => {
  return usePostMutation(
    improvementProposalCreateSchema,
    z.null(),
    `/console/improvement_proposals/${id}`,
    config,
  );
};
